module.exports = __webpack_public_path__ + "themes/non-default/integrationBanner.178cf0d86a9ab7670b825e836008f694.png";